module.exports = __webpack_public_path__ + "img/A8.f7f0e374.svg";